import Option from './Option';


Option.install = function(Vue) {
  Vue.component(Option.name, Option);
};

export default Option;
